import AttachFileIcon from '@mui/icons-material/AttachFile'
import { Badge, IconButton } from '@mui/material'
import * as React from 'react'

type OpenAttachmentsButtonProps = {
	selectAttachments: () => void
	attachmentCount?: number
}

export const OpenAttachmentsButton = ({ selectAttachments, attachmentCount }: OpenAttachmentsButtonProps) => {
	return (
		<>
			<IconButton
				onClick={() => {
					selectAttachments()
				}}
				title='View Attachments'
			>
				<Badge
					badgeContent={attachmentCount || 0}
					color="primary"
					sx={{
						'& .MuiBadge-badge': {
							right: 0,
							bottom: 0,
							mt: "5px",
							fontSize: '0.75rem',
							minWidth: '18px',
							height: '18px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							transform: 'translate(50%, 50%)',
						}
					}}
				>
					<AttachFileIcon
						sx={{ color: '#FFFFFF', background: '#0DAEFF', padding: '2px', borderRadius: '4px' }}
					/>
				</Badge>
			</IconButton>
		</>
	)
}
